module.exports = __webpack_public_path__ + "img/Z3RO.6f63f53b.png";